import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Checkbox,
  Grid,
  Typography,
  Box,
  Button,
  Menu,
  MenuItem,
  Modal,
  InputLabel,
  CircularProgress,
  Pagination,
  Select,
  FormControlLabel,
  Collapse,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import CloseIcon from "@mui/icons-material/Close";
import CustomTextField from "../../../Utils/CustomTextfield";
import {
  deleteBiller,
  getAllBillers,
  registeration,
  updateBiller,
  updateRegisteration,
} from "../../../api/action";
import { useDispatch, useSelector } from "react-redux";
import CustomSnackbar from "../../../Utils/CustomSnackbar";
import CustomPagination from "../../../Utils/CustomPagination";
import DeleteModal from "../../../Utils/DeleteModal";
import { phoneRegex } from "../../../Utils/Regex";
import * as XLSX from "xlsx";

const ROWS_PER_PAGE = 10; // Number of rows per page

const BillerBody = ({ onEdit, onDelete }) => {
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [searchFacilityCode, setSearchFacilityCode] = useState("");
  const [searchFacilityName, setSearchFacilityName] = useState("");
  const [searchFacilityType, setSearchFacilityType] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedFacility, setSelectedFacility] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [newStateName, setNewStateName] = useState("");
  const [lastName, setLastName] = useState("");
  const [editLastName, seEditLastName] = useState("");
  const [newStateCode, setNewStateCode] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [editStateName, setEditStateName] = useState("");
  const [editStateCode, setEditStateCode] = useState("");
  const [editEmail, setEditEmail] = useState("");
  const [editPhone, setEditPhone] = useState("");
  const [editPassword, setEditPassword] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("");
  const [loading, setLoading] = useState("");
  const [billerId, setBillerID] = useState("");
  const [updated, setUpdated] = useState(false);
  const [data, setData] = useState([]);
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const [emailError, setEmailError] = useState("");
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  // const userRole = localStorage.getItem("userRole");
     const userRole = useSelector((state) => state?.user?.userRole)
  const [editStatus, setEditStatus] = useState(false);
  const [userId, setUserId] = useState("");
  const [isDeletedAccess, setIsDeletedAccess] = useState(false);
  const [isEditDeletedAccess, setIsEditDeletedAccess] = useState(false);
  const [passwordMessage, setPasswordMessage] = useState("");
  const passwordRegex =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

  const handleDeletedAccess = (event) => {
    setIsDeletedAccess(event.target.checked);
  };

  const generatePassword = () => {
    const uppercase = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    const lowercase = "abcdefghijklmnopqrstuvwxyz";
    const numbers = "0123456789";
    const special = "@$!%*?&";
    const allChars = uppercase + lowercase + numbers + special;

    let password = "";

    while (!passwordRegex.test(password)) {
      password = "";
      password += uppercase[Math.floor(Math.random() * uppercase.length)];
      password += lowercase[Math.floor(Math.random() * lowercase.length)];
      password += numbers[Math.floor(Math.random() * numbers.length)];
      password += special[Math.floor(Math.random() * special.length)];

      // fill up to 12 chars
      for (let i = 4; i < 12; i++) {
        password += allChars[Math.floor(Math.random() * allChars.length)];
      }

      // shuffle
      password = password
        .split("")
        .sort(() => Math.random() - 0.5)
        .join("");
    }

    return password;
  };

  useEffect(() => {
    setLoading(true);
    const payload = null;
    dispatch(
      getAllBillers(
        payload,
        (data) => {
          setLoading(false);
          setData(data?.data?.Data);
        },
        (error) => {
          console.log(error);
          setLoading(false);
        }
      )
    );
  }, [updated]);

  const handleOpenEditModal = (selectedRow) => {
    setEditModalOpen(true);
    // Populate state variables with selected row data
    setEditStateName(selectedRow.First_Name);
    seEditLastName(selectedRow.Last_Name);
    setEditStateCode(selectedRow.billercode);
    setEditEmail(selectedRow.email);
    setEditPhone(selectedRow.Phone_number);
    setEditPassword(selectedRow.password);
    setBillerID(selectedRow.id);
    setEditStatus(selectedRow.is_active);
    setUserId(selectedRow.user_id);
    setIsEditDeletedAccess(selectedRow.is_deleted_access);
  };

  const handleSelectAll = (event) => {
    if (event.target.checked) {
      const selectedCodes = data.map((row) => row.billercode);
      setSelectedRows(selectedCodes);
    } else {
      setSelectedRows([]);
    }
    setSelectAll(event.target.checked);
  };

  const handleCheckboxChange = (facilityCode) => {
    const isSelected = selectedRows.includes(facilityCode);
    let updatedSelectedRows = [];
    if (isSelected) {
      updatedSelectedRows = selectedRows.filter(
        (code) => code !== facilityCode
      );
    } else {
      updatedSelectedRows = [...selectedRows, facilityCode];
    }
    setSelectedRows(updatedSelectedRows);
    setSelectAll(updatedSelectedRows.length === data.length);
  };

  const handleEditClick = (event, selectedFacility) => {
    setAnchorEl(event.currentTarget);
    setSelectedFacility(selectedFacility);
  };

  const handleEditClose = () => {
    setAnchorEl(null);
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const handleDelete = () => {
    onDelete(selectedRows);
    setSelectedRows([]);
  };

  const handleAddNew = () => {
    setShowModal(true);
  };

  useEffect(() => {
    setCurrentPage(1);
  }, [searchFacilityCode, searchFacilityName]);

  const filteredData = data?.filter((row) => {
    const matchesFacilityCode = row.billercode
      .toLowerCase()
      .includes(searchFacilityCode.toLowerCase());
    const matchesFacilityName =
      row.First_Name.toLowerCase().includes(searchFacilityName.toLowerCase()) ||
      row.Last_Name.toLowerCase().includes(searchFacilityName.toLowerCase());
    return matchesFacilityCode && matchesFacilityName;
  });

  const handleClearSearch = () => {
    setSearchFacilityCode("");
    setSearchFacilityName("");
    setSearchFacilityType("");
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setNewStateName("");
    setNewStateCode("");
    setPasswordMessage("");
  };

  const validateEmail = (value) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const isValid = emailRegex.test(value);
    return isValid;
  };

  const handleAddNewBiller = (e) => {
    if (!email || !password || !newStateName || !newStateCode) {
      setLoading(false);
      setSnackbarMessage("Please fill all the fields with valid data.");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
      return;
    }

    if (!phoneRegex.test(phone)) {
      setLoading(false);
      setSnackbarMessage("Please enter a valid phone number.");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
      return;
    }

    if (!emailRegex.test(email)) {
      setEmailError("Please enter a valid email address.");
      setLoading(false);
      setSnackbarMessage("Please enter a valid email address.");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
      return;
    }

    if (!passwordRegex.test(password)) {
      setLoading(false);
      setSnackbarMessage(
        "Password must be at least 8 characters long and include one uppercase letter, one lowercase letter, one number, and one special character (@$!%*?&)."
      );
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
      return;
    }

    const payload = {
      email,
      password,
      password2: password,
      first_name: newStateName.trim(),
      last_name: lastName.trim(),
      billercode: newStateCode,
      phone_number: phone,
      user_role: "Biller",
      is_active: true,
      is_deleted_access: isDeletedAccess,
    };

    setLoading(true);
    dispatch(
      registeration(
        payload,
        (data) => {
          setLoading(false);
          setSnackbarMessage("Biller added successfully");
          setSnackbarOpen(true);
          setSnackbarSeverity("success");
          setShowModal(false);
          setUpdated((prevState) => !prevState);
          setEmail("");
          setPassword("");
          setNewStateCode("");
          setNewStateName("");
          setPhone("");
          setLastName("");
        },
        (error) => {
          console.log(error);
          setLoading(false);
          const errorMessage =
            error.message === "Network Error"
              ? error.message
              : error.response?.data?.error ||
                "Oops! Looks like we need you to log in again to keep things secure!";
          setSnackbarMessage(errorMessage);
          setSnackbarSeverity("error");
          setSnackbarOpen(true);
        }
      )
    );
  };

  const handleUpdateBiller = (e) => {
    e.preventDefault();

    if (!editPassword || !editStateName || !editStateCode) {
      setLoading(false);
      setSnackbarMessage("Please fill all the fields with valid data.");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
      return;
    }

    if (!passwordRegex.test(editPassword)) {
      setLoading(false);
      setSnackbarMessage(
        "Password must be at least 8 characters long and include one uppercase letter, one lowercase letter, one number, and one special character (@$!%*?&)."
      );
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
      return;
    }

    const payload = {
      password: editPassword,
      first_name: editStateName.trim(),
      last_name: editLastName.trim(),
      biller_id: billerId,
      Phone_number: editPhone,
      is_active: editStatus,
      user_id: userId,
      is_deleted_access: isEditDeletedAccess,
    };

    setLoading(true);
    dispatch(
      updateBiller(
        payload,
        (data) => {
          setLoading(false);
          setSnackbarMessage("Biller updated successfully");
          setSnackbarOpen(true);
          setSnackbarSeverity("success");
          setEditModalOpen(false);
          setUpdated((prevState) => !prevState);
        },
        (error) => {
          console.log(error);
          setLoading(false);
          const errorMessage =
            error.message === "Network Error"
              ? error.message
              : error.response?.data?.detail ||
                "Oops! Looks like we need you to log in again to keep things secure!";
          setSnackbarMessage(errorMessage);
          setSnackbarSeverity("error");
          setSnackbarOpen(true);
        }
      )
    );
  };

  const handleDeleteBiller = (user_id) => {
    const payload = {
      user_id,
    };

    setLoading(true);
    dispatch(
      deleteBiller(
        payload,
        (data) => {
          setLoading(false);
          setSnackbarMessage("Biller deleted successfully");
          setSnackbarOpen(true);
          setSnackbarSeverity("success");
          setEditModalOpen(false);
          setUpdated((prevState) => !prevState);
          setOpenDeleteModal(false);
        },
        (error) => {
          console.log(error);
          setLoading(false);
          const errorMessage =
            error.message === "Network Error"
              ? error.message
              : error.response?.data?.detail ||
                "Oops! Looks like we need you to log in again to keep things secure!";
          setSnackbarMessage(errorMessage);
          setSnackbarSeverity("error");
          setSnackbarOpen(true);
        }
      )
    );
  };

  const handleSaveEditedState = () => {
    // Add your logic to save the new state (e.g., API call, updating state)
    // After saving, close the modal
    setShowModal(false);
    setPasswordMessage("");
  };

  const handleCloseEditModal = () => {
    setEditModalOpen(false);
    setPasswordMessage("")
  };

  const handleDeleteModal = (id) => {
    setOpenDeleteModal(true);
    setBillerID(id);
  };

  // Pagination Handlers
  const handleChangePage = (event, newPage) => {
    setCurrentPage(newPage);
  };

  const startIndex = (currentPage - 1) * ROWS_PER_PAGE;
  // Slice the data array to get only the data for the current page
  const paginatedData = filteredData.slice(
    startIndex,
    startIndex + ROWS_PER_PAGE
  );
  // Calculate the end index of the data for the current page
  const endIndex = startIndex + ROWS_PER_PAGE;

  const downloadSelectedRows = () => {
    // Filter rows based on selectedRows array
    const exportData = filteredData
      .filter((row) => selectedRows.includes(row.billercode))
      .map((row) => ({
        "Biller Code": row.billercode,
        "Biller Name": row?.First_Name + " " + row.Last_Name,
        "Email ID": row.email,
        "Phone Number": row.Phone_number,
      }));

    // Create a new workbook
    const wb = XLSX.utils.book_new();

    // Convert data to worksheet
    const ws = XLSX.utils.json_to_sheet(exportData);
    const columnWidths = [
      { wch: 15 }, // Width of Date column
      { wch: 20 }, // Width of Provider column
      { wch: 20 }, // Width of Facility Name column
      { wch: 20 }, // Width of Type of Job column
    ];

    ws["!cols"] = columnWidths;

    // Add worksheet to workbook
    XLSX.utils.book_append_sheet(wb, ws, "SelectedRows");

    // Save the workbook as an Excel file
    XLSX.writeFile(wb, "Billers.xlsx");
  };

  const handleEditGeneratePassword = () => {
    const newPassword = generatePassword();
    setEditPassword(newPassword);
    setPasswordMessage("✅ New password generated");
  };

  const handleGeneratePassword = () => {
    const newPassword = generatePassword();
    setPassword(newPassword);
    setPasswordMessage("✅ New password generated");
  };

  return (
    <Box sx={{ px: 5, py: 2 }}>
      <DeleteModal
        open={openDeleteModal}
        setOpen={setOpenDeleteModal}
        loading={loading}
        setLoading={setLoading}
        handleDeletefunction={handleDeleteBiller}
        id={billerId}
      />
      <Typography
        variant="h6"
        sx={{ color: "rgba(29, 57, 105, 1)", fontWeight: "bold", mb: 2 }}
      >
        Search Biller Master
      </Typography>
      <Grid container spacing={5}>
        <Grid item md={3} xs={6}>
          <InputLabel>Biller Code</InputLabel>
          <CustomTextField
            value={searchFacilityCode}
            setValue={setSearchFacilityCode}
          />
        </Grid>
        <Grid item md={3} xs={6}>
          <InputLabel>Biller Name</InputLabel>
          <CustomTextField
            value={searchFacilityName}
            setValue={setSearchFacilityName}
          />
        </Grid>
        <Grid item md={6} sm={6} xs={6}>
          <Box sx={{ display: "flex", justifyContent: "right" }}>
            <Button
              className="buttonPadding"
              variant="contained"
              onClick={handleClearSearch}
              sx={{
                boxShadow: "none !important",
                my: 3,
                mx: 1,
              }}
            >
              Clear
            </Button>
            <Button
              disabled={userRole !== "Admin"}
              className="buttonPadding"
              variant="contained"
              onClick={handleAddNew}
              sx={{
                background: userRole !== "Admin" ? "#d3d3d3" : null,
                boxShadow: "none !important",
                my: 3,
                mx: 1,
              }}
            >
              Add New
            </Button>
            {/* <Button
                            className='buttonPadding'
                            variant="contained"
                            onClick={handleDelete}
                            disabled={selectedRows.length === 0}
                            sx={{ background: selectedRows.length === 0 ? '#d2d2d2' : 'rgba(29, 57, 105, 1) !important', boxShadow: 'none !important', my: 3, mx: 1 }}
                        >
                            Delete
                        </Button> */}

            <Button
              className="buttonPadding"
              variant="contained"
              onClick={downloadSelectedRows}
              disabled={selectedRows.length === 0}
              sx={{
                boxShadow: "none !important",
                background: selectedRows.length === 0 ? "#d2d2d2" : null,
                my: 3,
                mx: 1,
              }}
            >
              Download Excel
            </Button>
          </Box>
        </Grid>
      </Grid>

      <Box sx={{}}>
        {loading ? ( // Render CircularProgress while loading is true
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "40vh",
            }}
          >
            <CircularProgress sx={{ color: "rgba(29, 57, 105, 1) !important" }} />
          </Box>
        ) : filteredData.length === 0 ? (
          <Typography
            variant="body2"
            sx={{ textAlign: "center", color: "#555", mt: 15 }}
          >
            No Data Available
          </Typography>
        ) : (
          <>
            <TableContainer component={Paper} className="scrollBar">
              <Table>
                <TableHead
                  sx={{
                    background:
                    "rgba(29, 57, 105, 1)",
                    color: "#fff",
                  }}
                >
                  <TableRow>
                    <TableCell
                      sx={{
                        py: 0,
                        color: "#fff",
                        display: "flex",
                        justifyContent: "left",
                        alignItems: "center",
                        verticalAlign: "middle",
                      }}
                    >
                      <Checkbox
                        checked={selectAll}
                        onChange={handleSelectAll}
                        sx={{ color: "#fff !important" }}
                      />
                    </TableCell>
                    <TableCell sx={{ color: "#fff", py: 0 }}>
                      Biller Code
                    </TableCell>
                    <TableCell sx={{ color: "#fff", py: 0 }}>
                      Biller Name
                    </TableCell>
                    <TableCell sx={{ color: "#fff", py: 0 }}>
                      Email ID
                    </TableCell>
                    <TableCell sx={{ color: "#fff", py: 0 }}>
                      Phone Number
                    </TableCell>
                    <TableCell
                      sx={{ color: "#fff", py: 0, whiteSpace: "nowrap" }}
                    >
                      Status
                    </TableCell>
                    <TableCell sx={{ color: "#fff", py: 0 }}>
                      Password
                    </TableCell>
                    <TableCell sx={{ color: "#fff", py: 0 }}>Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filteredData.slice(startIndex, endIndex).map((row) => (
                    <TableRow key={row.facilityCode}>
                      <TableCell sx={{ py: 0.3 }}>
                        <Checkbox
                          size="small"
                          checked={selectedRows.includes(row.billercode)}
                          onChange={() => handleCheckboxChange(row.billercode)}
                          style={{ color: "rgba(29, 57, 105, 1)" }}
                        />
                      </TableCell>
                      <TableCell className="fs12" sx={{ py: 0.3 }}>
                        {row?.billercode}
                      </TableCell>
                      <TableCell className="fs12" sx={{ py: 0.3 }}>
                        {row?.First_Name + " " + row.Last_Name}
                      </TableCell>
                      <TableCell className="fs12" sx={{ py: 0.3 }}>
                        {row?.email}
                      </TableCell>
                      <TableCell sx={{ py: 0.3 }}>
                        {row?.Phone_number}
                      </TableCell>
                      <TableCell
                        className="fs12"
                        sx={{ py: 0.3, whiteSpace: "nowrap" }}
                      >
                        {row?.is_active === true ? "Active" : "Inactive"}
                      </TableCell>
                      <TableCell className="fs12" sx={{ py: 0.3 }}>
                        {"*********"}
                      </TableCell>
                      <TableCell sx={{ py: 0.3 }}>
                        <IconButton
                          disabled={userRole !== "Admin"}
                          color="primary"
                          onClick={() => handleOpenEditModal(row)}
                        >
                          <EditIcon
                            sx={{
                              color:
                                userRole !== "Admin" ? "#d3d3d3" : "rgba(29, 57, 105, 1)",
                              fontSize: "16px",
                            }}
                          />
                        </IconButton>
                        <IconButton
                          disabled={userRole !== "Admin"}
                          color="secondary"
                          onClick={() => handleDeleteModal(row.user_id)}
                        >
                          <DeleteIcon
                            sx={{
                              color:
                                userRole !== "Admin" ? "#d3d3d3" : "rgba(29, 57, 105, 1)",
                              fontSize: "16px",
                            }}
                          />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <CustomPagination
              count={Math.ceil(filteredData.length / ROWS_PER_PAGE)}
              page={currentPage}
              onChange={handleChangePage}
            />
          </>
        )}

        <CustomSnackbar
          open={snackbarOpen}
          handleClose={handleSnackbarClose}
          message={snackbarMessage}
          severity={snackbarSeverity}
        />
      </Box>

      {/* ADD MODAL */}

      <Modal
        open={showModal}
        onClose={handleCloseModal}
        sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
      >
        <Box
          sx={{
            background: "#fff",
            width: "40vw",
            px: 5,
            py: 5,
            mx: "auto",
            borderRadius: "6px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              verticalAlign: "middle",
            }}
          >
            <Typography
              className="fs16"
              sx={{ fontWeight: 600, color: "rgba(29, 57, 105, 1)" }}
            >
              Add New State
            </Typography>
            <IconButton onClick={handleCloseModal}>
              <CloseIcon
                sx={{
                  color: "#fff",
                  background: "rgba(29, 57, 105, 1)",
                  borderRadius: "25px",
                  height: 20,
                  width: 20,
                  p: 0.5,
                }}
              />
            </IconButton>
          </Box>
          <Box sx={{ my: 2 }}>
            <Grid container spacing={3}>
              <Grid item md={6}>
                <InputLabel>Biller code</InputLabel>
                <CustomTextField
                  label="Biller code"
                  value={newStateCode}
                  setValue={setNewStateCode}
                />
              </Grid>
              <Grid item md={6}>
                <InputLabel>Biller First Name</InputLabel>
                <CustomTextField
                  label="First Name"
                  value={newStateName}
                  setValue={setNewStateName}
                />
              </Grid>

              <Grid item md={6}>
                <InputLabel>Biller Last Name</InputLabel>
                <CustomTextField
                  label="Last Name"
                  value={lastName}
                  setValue={setLastName}
                />
              </Grid>

              <Grid item md={6}>
                <InputLabel>Email</InputLabel>
                <CustomTextField
                  label="Email"
                  value={email}
                  setValue={setEmail}
                />
              </Grid>
              <Grid item md={6}>
                <InputLabel>Phone Number</InputLabel>
                <CustomTextField
                  label="Phone Number"
                  value={phone}
                  setValue={setPhone}
                />
              </Grid>
              <Grid item md={12}>
                <InputLabel>Password</InputLabel>
                <Grid container spacing={2}>
                  {/* 8 columns for password field */}
                  <Grid item xs={8}>
                    <CustomTextField
                      value={password}
                      setValue={setPassword}
                      fullWidth
                      type="password"
                    />
                  </Grid>

                  {/* 4 columns for generate button */}
                  <Grid item xs={4}>
                    <Button
                      fullWidth
                      variant="outlined"
                      onClick={handleGeneratePassword}
                      sx={{
                        whiteSpace: "nowrap",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "100%",
                      }}
                    >
                      <Typography variant="caption">
                        Generate Password
                      </Typography>
                    </Button>
                  </Grid>
                </Grid>
                <Collapse in={Boolean(passwordMessage)}>
                  <Typography variant="caption" sx={{ color: "green" }}>
                    {passwordMessage}
                  </Typography>
                </Collapse>
                <Typography
                  variant="caption"
                  color="textSecondary"
                  sx={{ display: "block", mt: 0.5 }}
                >
                  Password must be at least 8 characters long, and include one
                  uppercase letter, one lowercase letter, one number, and one
                  special character (@$!%*?&).
                </Typography>
              </Grid>
            </Grid>
            <FormControlLabel
              value="start"
              control={
                <Checkbox
                  checked={isDeletedAccess}
                  onChange={handleDeletedAccess}
                />
              }
              label={
                <Typography style={{ fontWeight: "bold", color: "rgba(29, 57, 105, 1)" }}>
                  Eligible for Superbill deletion
                </Typography>
              }
              labelPlacement="start"
              sx={{ px: 0, mx: 0, mt: 2 }}
            />
          </Box>
          <Button
            variant="contained"
            onClick={handleAddNewBiller}
            sx={{
             
              boxShadow: "none !important",
              display: "block",
              mt: 3,
              ml: "auto",
            }}
          >
            {loading ? (
              <CircularProgress size={18} sx={{ color: "#fff" }} />
            ) : (
              "Add"
            )}
          </Button>
        </Box>
      </Modal>

      {/* EDIT MODAL */}

      <Modal
        open={editModalOpen}
        onClose={handleCloseEditModal}
        sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
      >
        <Box
          sx={{
            background: "#fff",
            width: "40vw",
            px: 5,
            py: 5,
            mx: "auto",
            borderRadius: "6px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              verticalAlign: "middle",
            }}
          >
            <Typography
              className="fs16"
              sx={{ fontWeight: 600, color: "rgba(29, 57, 105, 1)" }}
            >
              Edit State
            </Typography>
            <IconButton onClick={handleCloseEditModal}>
              <CloseIcon
                sx={{
                  color: "#fff",
                  background: "rgba(29, 57, 105, 1)",
                  borderRadius: "25px",
                  height: 20,
                  width: 20,
                  p: 0.5,
                }}
              />
            </IconButton>
          </Box>
          <Box sx={{ my: 2 }}>
            <Grid container spacing={3}>
              <Grid item md={6}>
                <InputLabel>Biller code</InputLabel>
                <CustomTextField
                  label="Biller code"
                  value={editStateCode}
                  setValue={setEditStateCode}
                  disabled
                />
              </Grid>
              <Grid item md={6}>
                <InputLabel>First Name</InputLabel>
                <CustomTextField
                  label="Biller Name"
                  value={editStateName}
                  setValue={setEditStateName}
                />
              </Grid>

              <Grid item md={6}>
                <InputLabel>Last Name Name</InputLabel>
                <CustomTextField
                  label="Biller Name"
                  value={editLastName}
                  setValue={seEditLastName}
                />
              </Grid>

              <Grid item md={6}>
                <InputLabel>Email</InputLabel>
                <CustomTextField
                  label="Email"
                  value={editEmail}
                  setValue={setEditEmail}
                  disabled
                />
              </Grid>
              <Grid item md={6}>
                <InputLabel>Phone Number</InputLabel>
                <CustomTextField
                  label="Phone Number"
                  value={editPhone}
                  setValue={setEditPhone}
                />
              </Grid>

              <Grid item md={6} xs={6}>
                <InputLabel>Status</InputLabel>
                <Select
                  fullWidth
                  value={editStatus}
                  onChange={(e) => setEditStatus(e.target.value)}
                  sx={{ height: "32px", padding: "5px 5px", fontSize: "12px" }}
                >
                  <MenuItem value={true}>Active</MenuItem>

                  <MenuItem value={false}>Inactive</MenuItem>
                </Select>
              </Grid>
              <Grid item md={12}>
                <InputLabel>Password</InputLabel>
                <Grid container spacing={2}>
                  {/* 8 columns for password field */}
                  <Grid item xs={8}>
                    <CustomTextField
                      value={editPassword}
                      setValue={setEditPassword}
                      fullWidth
                      type={"password"}
                    />
                  </Grid>

                  {/* 4 columns for generate button */}
                  <Grid item xs={4}>
                    <Button
                      // variant="outlined"
                      onClick={handleEditGeneratePassword}
                    >
                      <Typography
                        variant="caption"
                        // sx={{ display: "block", mt: 0.5 }}
                      >
                        Generate Password
                      </Typography>
                    </Button>
                  </Grid>
                </Grid>

                <Collapse in={Boolean(passwordMessage)}>
                  <Typography variant="caption" sx={{ color: "green" }}>
                    {passwordMessage}
                  </Typography>
                </Collapse>
                <Typography
                  variant="caption"
                  color="textSecondary"
                  sx={{ display: "block", mt: 0.5 }}
                >
                  Password must be at least 8 characters long, and include one
                  uppercase letter, one lowercase letter, one number, and one
                  special character (@$!%*?&).
                </Typography>
              </Grid>
            </Grid>
            <FormControlLabel
              value="start"
              control={
                <Checkbox
                  checked={isEditDeletedAccess}
                  onChange={(event) =>
                    setIsEditDeletedAccess(event.target.checked)
                  }
                />
              }
              label={
                <Typography style={{ fontWeight: "bold", color: "rgba(29, 57, 105, 1)" }}>
                  Eligible for Superbill deletion
                </Typography>
              }
              labelPlacement="start"
              sx={{ px: 0, mx: 0, mt: 2 }}
            />
          </Box>
          <Button
            variant="contained"
            onClick={handleUpdateBiller}
            sx={{
            
              boxShadow: "none !important",
              display: "block",
              mt: 3,
              ml: "auto",
            }}
          >
            {loading ? (
              <CircularProgress size={18} sx={{ color: "#fff" }} />
            ) : (
              "Update"
            )}
          </Button>
        </Box>
      </Modal>
    </Box>
  );
};

export default BillerBody;
